import * as z from "zod";

export function getItem<T>(key: string, schema: z.ZodType<T>): T | undefined;
export function getItem<T>(
  key: string,
  schema: z.ZodType<T>,
  defaultValue: T,
): T;
export function getItem<T>(
  key: string,
  schema: z.ZodType<T>,
  defaultValue?: T,
): T | undefined {
  const item = localStorage.getItem(key);

  if (item === null) {
    return defaultValue;
  }

  return schema.parse(JSON.parse(item));
}

export function setItem<T>(key: string, value: T) {
  return localStorage.setItem(key, JSON.stringify(value));
}

export function removeItem(key: string) {
  return localStorage.removeItem(key);
}
